import React from "react";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import {
  FormInput,
  Form as AppForm,
  PhoneNumberField,
  form
} from "MODULES/shared/components/Forms";
import { Field, FieldArray } from "redux-form";
import { properCase } from "LIB/formatters/text";
import { Col } from "react-bootstrap";
import {
  ATTACHMENTS,
  COMPANY_NAME,
  EMAIL,
  LINE_ITEMS,
  NAME
} from "APP_ROOT/constants";
import { ATTACHMENT_TYPES } from "MODULES/IncomingQuotes/constants";
import Attachments from "MODULES/Customers/IncomingQuote/AddAttachments";
import validate from "./validate";
import Row from "./Row";

const FORM_NAME = "customerRfq";

function Form(props) {
  const { incomingQuote, quoted } = props;

  return (
    <FormRow>
      <Col md={6} mdOffset={3}>
        <div className="panel panel-default">
          <div className="panel-body">
            <AppForm {...props}>
              <AppForm.Body>
                <FormRow>
                  <Col md={6}>
                    <Field
                      component={FormInput}
                      name={NAME}
                      label={properCase(NAME)}
                      disabled={quoted}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      name={EMAIL}
                      component={FormInput}
                      label={EMAIL}
                      disabled={quoted}
                      required
                    />
                  </Col>
                </FormRow>
                <FormRow>
                  <Col md={9}>
                    <Field
                      component={FormInput}
                      name={COMPANY_NAME}
                      label={properCase(COMPANY_NAME)}
                      disabled
                    />
                  </Col>
                </FormRow>
                <FormRow>
                  <Col md={6}>
                    <PhoneNumberField
                      name="phone1"
                      component={FormInput}
                      disabled={quoted}
                      label="Phone Number 1"
                    />
                  </Col>
                </FormRow>
                <FormRow>
                  <Col md={12}>
                    <table className="table table-striped table-numbered margin-bottom-none">
                      <FieldArray
                        name={LINE_ITEMS}
                        component={Row}
                        formName={FORM_NAME}
                        incomingQuote={incomingQuote}
                      />
                    </table>
                  </Col>
                </FormRow>
                <FormRow>
                  <Col md={12}>
                    <hr className="hr-xs hr-dashed" />
                    <FieldArray
                      name={ATTACHMENTS}
                      component={Attachments}
                      attachmentTypes={ATTACHMENT_TYPES}
                    />
                  </Col>
                </FormRow>
              </AppForm.Body>
            </AppForm>
          </div>
        </div>
      </Col>
    </FormRow>
  );
}

export default form({
  form: FORM_NAME,
  validate
})(Form);



// WEBPACK FOOTER //
// ./app/modules/Customers/IncomingQuote/Form.jsx